import { render, staticRenderFns } from "./Satellite.vue?vue&type=template&id=68cf422e&"
import script from "./Satellite.vue?vue&type=script&lang=js&"
export * from "./Satellite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports